import React from 'react';
import Modal from 'react-modal';

import * as S from './styled';

const getCustomStyles = initial => ({
  overlay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    overflow: 'hidden auto',
    paddingBottom: '50px',
    zIndex: 9999,
    ...initial.overlay,
  },
  content: {
    padding: 0,
    borderRadius: 0,
    position: 'relative',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    marginTop: '50px',
    marginBottom: 'auto',
    width: '650px',
    border: 'none',
    outline: 'none',
    overflow: 'visible',
    ...initial.content,
  },
});

type Props = {
  title?: string,
  isOpen: boolean,
  isError?: boolean,
  hideHeader?: boolean,
  children: React.ReactNode,
  overlayStyle?: React.CSSProperties,
  contentStyle?: React.CSSProperties,
  hideCloseButton?: boolean,
  onRequestClose?: { (): void },
};

const MainModal = ({
  title,
  isOpen,
  isError = false,
  children,
  hideCloseButton = false,
  hideHeader = false,
  overlayStyle = {},
  contentStyle = {},
  onRequestClose,
}: Props) => (
  <Modal
    isOpen={isOpen}
    ariaHideApp={false}
    onRequestClose={onRequestClose}
    style={
      getCustomStyles({
        overlay: overlayStyle || {},
        content: contentStyle || {},
      })
    }
    appElement={document.body}
  >
    {!hideHeader && (
      <S.Header isError={isError}>
        <S.Title>
          {title}
        </S.Title>
        {!hideCloseButton && (
          <S.Close onClick={onRequestClose}>Close</S.Close>
        )}
      </S.Header>
    )}
    <S.Body>
      {children}
    </S.Body>
  </Modal>
);

export default MainModal;
